<template>
    <div class="fixed z-20 inset-0 overflow-y-auto">
        <div class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
            <transition name="fade" appear>
                <div class="fixed inset-0 transition-opacity" aria-hidden="true">
                    <div class="absolute inset-0 bg-gray-500 opacity-75"></div>
                </div>
            </transition>

            <span class="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">&#8203;</span>

            <transition name="pop" appear>
                <div class="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full" role="dialog" aria-modal="true" aria-labelledby="modal-headline">
                    <div class="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
                        <div class="text-lg text-center">
                            <h3 class="text-lg leading-6 font-medium text-gray-900">
                                {{$t('You have unfinished rounds!')}}
                            </h3>
                        </div>
                    </div>
                    <div class="bg-gray-50 p-2 sm:flex sm:flex-row-reverse">
                        <button type="button" class="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-red-600 text-base font-medium text-white hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 sm:ml-3 sm:text-sm" @click="forceLogout">
                            {{$t('Logout')}}
                        </button>
                        <button type="button" :disabled="isGameOpening" class="mt-3 w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-blue-600 text-base font-medium text-white hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 sm:mt-0 sm:ml-3 sm:text-sm" @click="openGame">
                            {{$t('Open game')}}
                        </button>
                        <button type="button" class="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:mt-0 sm:ml-3 sm:text-sm" @click="cancelLogout">
                            {{$t('Cancel')}}
                        </button>
                    </div>
                </div>
            </transition>
        </div>
    </div>
</template>

<script>
import GameMixin from "../../Shared/mixin/Game";

export default {
    name: "LogoutModal",
    mixins: [
        GameMixin,
    ],
    props: {
        openRoundGameId: Number
    },
    methods: {
        cancelLogout() {
            this.$emit('close');
        },
        async forceLogout() {
            this.$emit('forceLogout');
        },
        openGame() {
            this.openCasinoGame(this.openRoundGameId);
        },
    },
};
</script>


<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
    transition: opacity .3s linear;
}
.fade-enter,
.fade-leave-to {
    opacity: 0;
}

.pop-enter-active,
.pop-leave-active {
    transition: transform 0.3s cubic-bezier(0.5, 0, 0.5, 1), opacity 0.3s linear;
}

.pop-enter,
.pop-leave-to {
    opacity: 0;
    transform: scale(0.2) translateY(-30%);
}
</style>
